export const hideListSmall = 'hidden @2xl/list:inline';
